import { render, staticRenderFns } from "./wt-radio-input.vue?vue&type=template&id=61782400"
import script from "./wt-radio-input.vue?vue&type=script&lang=js"
export * from "./wt-radio-input.vue?vue&type=script&lang=js"
import style0 from "./wt-radio-input.vue?vue&type=style&index=0&id=61782400&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports